import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaFacebookF } from 'react-icons/fa';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-brand-mark">
              <img
                src="/images/logo-footer.webp"
                alt="Damtua Inn"
                className="footer-logo"
                width={160}
                height={114}
                loading="lazy"
                decoding="async"
              />
              <div className="footer-brand-text">
                <span className="footer-brand-pretitle">The</span>
                <h3>Damtua Inn</h3>
              </div>
            </div>
            <p className="footer-tagline">
              A quiet hill retreat in Alikadam, Bandarban — rooms, restaurant,
              and gatherings shaped by the slow rhythm of the surrounding forest.
            </p>
            <a
              href="https://www.facebook.com/profile.php?id=100057598592990"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Damtua Inn on Facebook"
              className="footer-social"
            >
              <FaFacebookF />
            </a>
          </div>

          <div className="footer-col">
            <p className="footer-heading">Visit</p>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/rooms">Rooms &amp; Suites</Link></li>
              <li><Link to="/restaurant">Dining</Link></li>
              <li><Link to="/community-center">Events</Link></li>
              <li><Link to="/about">Our Story</Link></li>
              <li><Link to="/booking">Reserve</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <p className="footer-heading">Services</p>
            <ul className="footer-links">
              <li><Link to="/community-center">Community Pavilion</Link></li>
              <li><Link to="/restaurant">Restaurant</Link></li>
              <li><Link to="/rooms">Accommodation</Link></li>
              <li><Link to="/about#find-us">Tourist Guide</Link></li>
              <li><Link to="/about#find-us">Transport</Link></li>
            </ul>
          </div>

          <div className="footer-col footer-contact">
            <p className="footer-heading">Contact</p>
            <ul className="footer-contact-list">
              <li>
                <FiMapPin className="footer-contact-icon" />
                <a
                  href="https://maps.app.goo.gl/SNBGwZmw6UttUV7G8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Damtua, Alikadam<br />Bandarban, Bangladesh
                </a>
              </li>
              <li>
                <FiPhone className="footer-contact-icon" />
                <div>
                  <a href="tel:+8801879917302">+880 1879 917 302</a><br />
                  <a href="tel:+8801748912127">+880 1748 912 127</a>
                </div>
              </li>
              <li>
                <FiMail className="footer-contact-icon" />
                <a href="mailto:thedamtuainn@gmail.com">thedamtuainn@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-rule" />

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p className="copyright">
            © {new Date().getFullYear()} Damtua Inn Hotel &amp; Restaurant. All rights reserved.
          </p>
          <nav className="footer-bottom-links" aria-label="Legal">
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/refund-policy">Refund</Link>
            <Link to="/booking-policy">Booking</Link>
            <Link to="/terms-of-service">Terms</Link>
            <Link to="/admin">Admin</Link>
          </nav>
        </div>
        <p className="developer-credit">
          Crafted by <Link to="/developer" className="developer-link">Malthas Chakma</Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
